import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Messages } from '../../../messages/Messages';
import {
  SortDirection,
  SortableColumn
} from '../../../services/state/termin-tabelle-sorting.service';
import {
  CompareFunction,
  DropdownComponent,
  DropdownItem,
  DropdownObjectItem,
  LabelFunction
} from '../../dropdown/dropdown.component';

export type SortColDropdownItem = DropdownObjectItem<{
  col: SortableColumn;
  direction: SortDirection;
}>;
const getSortableColumnsMobile = (): SortColDropdownItem[] => {
  return [
    {
      id: '0',
      label: 'Beginn (frühester)',
      value: { col: SortableColumn.BEGINN, direction: SortDirection.ASCENDING }
    },
    {
      id: '1',
      label: 'Beginn (spätester)',
      value: { col: SortableColumn.BEGINN, direction: SortDirection.DESCENDING }
    },
    {
      id: '2',
      label: 'Dauer (kürzeste)',
      value: { col: SortableColumn.DAUER, direction: SortDirection.ASCENDING }
    },
    {
      id: '3',
      label: 'Dauer (längste)',
      value: { col: SortableColumn.DAUER, direction: SortDirection.DESCENDING }
    },
    {
      id: '4',
      label: 'Ort (A-Z)',
      value: { col: SortableColumn.ORT, direction: SortDirection.ASCENDING }
    },
    {
      id: '5',
      label: 'Ort (Z-A)',
      value: { col: SortableColumn.ORT, direction: SortDirection.DESCENDING }
    }
  ];
};

@Component({
  selector: 'now-wbsuche-lib-mobile-column-sort',
  templateUrl: './mobile-column-sort.component.html',
  imports: [DropdownComponent]
})
export class MobileColumnSortComponent implements OnChanges {
  @Input({ required: true })
  public angebotId!: number;
  @Input({ required: true })
  public sortDirection!: SortDirection;
  @Input({ required: true })
  public sortColumn!: SortableColumn;
  @Output()
  public sortChanged = new EventEmitter<SortColDropdownItem>();

  public messages = Messages;
  public mobileSortableColumns = getSortableColumnsMobile();
  public selectedValue?: SortColDropdownItem;

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.sortDirection?.currentValue != changes.sortDirection?.previousValue ||
      changes.sortColumn?.currentValue != changes.sortColumn?.previousValue
    ) {
      const selectedValue = this.mobileSortableColumns.find(
        (item) => item.value.col === this.sortColumn && item.value.direction === this.sortDirection
      );
      this.selectedValue = selectedValue;
    }
  }

  public selectionChanged(item: DropdownItem<any>): void {
    this.sortChanged.emit(item as SortColDropdownItem);
  }

  public sortDropdownLabel: LabelFunction = (item: SortColDropdownItem) => {
    return item.label;
  };

  public optionCompareFunction: CompareFunction = (
    active: SortColDropdownItem,
    fromList: SortColDropdownItem
  ) => {
    return active?.id === fromList?.id;
  };
}
